(function () {
'use strict';

angular.module('app.performanceReportTimeline')
  .controller('performanceReportTimelineCtrl', 
    ['$scope', '$rootScope', 'measureService', 'performanceReportTimelineService','$http', '$controller',
    function ($scope, $rootScope, measureService, performanceReportTimelineService, $http, $controller){
        
        $scope.activityLineChart = {
          options: {
              chart: {
                  type: 'line',
                  zoomType: 'x',
                  marginTop: 70,
                  events: {
                      redraw: function(){
                          $('.highcharts-markers').attr('visibility', 'hidden');
                      }
                  }                  
              },
              legend: {
                itemDistance: 25,
                verticalAlign: 'top',
                align: 'right',
                x: -10,
                useHTML: true,
                labelFormatter: function () {
                  return '<div class="custom_legend_background"></div><div class="custom_legend_symbol custom_legend_symbol_' + this.name + '" style="background-color:' + this.color + '"></div><div class="custom_legend_title">' + this.name + '</div>' + this.name;
                }
              },
              plotOptions: {
                line: {
                    marker: {
                        enabled: true,
                        symbol: "circle",
                        fillColor: "#fff",
                        lineColor: null,
                        lineWidth: 3,
                        radius: 4,
                        states: {
                            hover: {
                                enabled: true,
                                symbol: "circle",
                                fillColor: "#fff",
                                lineColor: "#000",
                                lineWidth: 3,
                                radius: 4
                            }
                        }
                    },
                    events: {
                        mouseOver: function (event) {
                            this.markerGroup.attr('visibility', 'visible');
                        },
                        mouseOut: function(event) {
                            this.markerGroup.attr('visibility', 'hidden');
                        }
                    }
                },
                series: {
                    events: {
                        legendItemClick: function (event) {
                            event= event|| window.event;
                            var visibility = this.visible ? 'visible' : 'hidden';
                            if (visibility == 'visible'){
                                event.target.legendGroup.div.childNodes[0].childNodes[2].classList.add('performance-report-timeline-chart-legend-title-show');
                                event.target.legendGroup.div.childNodes[0].childNodes[1].classList.add('performance-report-timeline-chart-legend-title-hide');
                            } else{
                                event.target.legendGroup.div.childNodes[0].childNodes[2].classList.remove('performance-report-timeline-chart-legend-title-show');
                                event.target.legendGroup.div.childNodes[0].childNodes[1].classList.remove('performance-report-timeline-chart-legend-title-hide');
                            }
                        }
                    }
                }
              },
              tooltip: {
                useHTML: true,
                followPointer: false,
                backgroundColor: "#333b48",
                pointFormatter: function () {
                    return '<b>' + Highcharts.numberFormat(this.y, 0, 0, ',') + '</b>';
                },
                headerFormat: "",
                borderRadius: 24,
                borderWidth: 0,
                shadow: false,
                shape: "callout",
                style: {
                    "color": "#FFFFFF",
                    "padding": "6"
                }
              }
          },
          series: [],                       
          title: {
              text: 'Performance Timeline',
              align: 'left',
              y: 15,
              useHTML: true,
              style: {
                fontFamily: "ProximaNovaSemibold",
                fontSize: "16px",
                color: "#4B5567",
                textTransform: "uppercase"
              }
          },
          xAxis: {
              type: 'datetime',
              dateTimeLabelFormats: {
                  day: '%e %b'
              },              
              labels: {
                  y: 40,
                  useHTML: true,
                  style: {
                      textTransform: "uppercase",
                      fontFamily: "ProximaNovaSemibold",
                      fontSize: "12px"
                  },
              },
              tickLength: 0
          },
          yAxis: {
              title: {
                  text: null
              },
              labels: {
                useHTML: true,
                style: {
                    textTransform: "uppercase",
                    fontFamily: "ProximaNovaSemibold",
                    fontSize: "12px"
                },
                formatter: function () {
                    return Highcharts.numberFormat(this.value, 0, 0, ',');
                }
              }
          },
          noData: 'Pending Data...',
          loading: true
        };

        $scope.printActivityLineChart = {
          options: {
              chart: {
                  type: 'line',
                  zoomType: 'x',
                  marginTop: 70,
                  events: {
                      redraw: function(){
                          $('.highcharts-markers').attr('visibility', 'hidden');
                      }
                  }                  
              },
              legend: {
                itemDistance: 25,
                verticalAlign: 'top',
                align: 'right',
                x: -10,
                useHTML: true,
                labelFormatter: function () {
                  return '<div class="custom_legend_background"></div><div class="custom_legend_symbol custom_legend_symbol_' + this.name + '" style="background-color:' + this.color + '"></div><div class="custom_legend_title">' + this.name + '</div>' + this.name;
                }
              },
              plotOptions: {
                line: {
                    marker: {
                        enabled: true,
                        symbol: "circle",
                        fillColor: "#fff",
                        lineColor: null,
                        lineWidth: 3,
                        radius: 4,
                        states: {
                            hover: {
                                enabled: true,
                                symbol: "circle",
                                fillColor: "#fff",
                                lineColor: "#000",
                                lineWidth: 3,
                                radius: 4
                            }
                        }
                    },
                    events: {
                        mouseOver: function (event) {
                            this.markerGroup.attr('visibility', 'visible');
                        },
                        mouseOut: function(event) {
                            this.markerGroup.attr('visibility', 'hidden');
                        }
                    }
                },
                series: {
                    events: {
                        legendItemClick: function (event) {
                            event= event|| window.event;
                            var visibility = this.visible ? 'visible' : 'hidden';
                            if (visibility == 'visible'){
                                event.target.legendGroup.div.childNodes[0].childNodes[2].classList.add('performance-report-timeline-chart-legend-title-show');
                                event.target.legendGroup.div.childNodes[0].childNodes[1].classList.add('performance-report-timeline-chart-legend-title-hide');
                            } else{
                                event.target.legendGroup.div.childNodes[0].childNodes[2].classList.remove('performance-report-timeline-chart-legend-title-show');
                                event.target.legendGroup.div.childNodes[0].childNodes[1].classList.remove('performance-report-timeline-chart-legend-title-hide');
                            }
                        }
                    }
                }
              },
              tooltip: {
                useHTML: true,
                followPointer: false,
                backgroundColor: "#333b48",
                pointFormatter: function () {
                    return '<b>' + Highcharts.numberFormat(this.y, 0, 0, ',') + '</b>';
                },
                headerFormat: "",
                borderRadius: 24,
                borderWidth: 0,
                shadow: false,
                shape: "callout",
                style: {
                    "color": "#FFFFFF",
                    "padding": "6"
                }
              }
          },
          series: [],                       
          title: {
              text: 'Performance Timeline',
              align: 'left',
              y: 15,
              useHTML: true,
              style: {
                fontFamily: "ProximaNovaSemibold",
                fontSize: "28px",
                color: "#4B5567",
                textTransform: "uppercase"
              }
          },
          xAxis: {
              type: 'datetime',
              dateTimeLabelFormats: {
                  day: '%e %b'
              },              
              labels: {
                  y: 40,
                  useHTML: true,
                  style: {
                      textTransform: "uppercase",
                      fontFamily: "ProximaNovaSemibold",
                      fontSize: "20px"
                  },
              },
              tickLength: 0,
              tickPixelInterval: 150
          },
          yAxis: {
              title: {
                  text: null
              },
              labels: {
                useHTML: true,
                style: {
                    textTransform: "uppercase",
                    fontFamily: "ProximaNovaSemibold",
                    fontSize: "20px"
                },
                formatter: function () {
                    return Highcharts.numberFormat(this.value, 0, 0, ',');
                }
              }
          },
          noData: 'Pending Data...',
          loading: true
        };
       
        //Watch on change keyword / blog / project change
        $scope.$on('refreshDashboard', function(event, args) {
            getDataPerformanceReportTimelineChart();
        });

        function getDataPerformanceReportTimelineChart() {
            var params = $rootScope.saveParams;
            if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
              return;
            } 
            params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

            getPerformanceTimelineData(params);
        }

        //Send request to get data for generating chart
        function getPerformanceTimelineData(params){
            //Hanlde for performance timeline graph
            $scope.activityLineChart.loading = true;
            $scope.printActivityLineChart.loading = true;
            //Use real data
              performanceReportTimelineService.getPerformanceTimelineData(params)
                .then(function(response){
                    genPerformanceTimeline(response.data.data);
                })
                .catch(function(message){
                    $scope.activityLineChart.series = [];
                    $scope.printActivityLineChart.series = [];
                })
                .finally(function(){
                  $scope.activityLineChart.loading = false;    
                  $scope.printActivityLineChart.loading = false;  
                  $rootScope.$broadcast('sectionLoaded');
                })
        }

        //Generate chart
        function genPerformanceTimeline(data){
            var engagementLine = { name: 'Engagement', data: [], color: '#00D6EF', lineWidth: 4};
            var impressionsLine = { name: 'Impressions', data: [], color: '#55E9A9', lineWidth: 4};
            var reachLine = { name: 'Reach', data: [], color: '#FF6C9D', lineWidth: 4};

            if(data != null && data.length > 0){
              angular.forEach(data, function(result) {
                  engagementLine.data.push([result.date, Math.round(result.engagement)]);
                  impressionsLine.data.push([result.date, Math.round(result.impressions)]);
                  reachLine.data.push([result.date, Math.round(result.reach)]);
              }) 
            }

            //Push data to series to draw chart
            $scope.activityLineChart.series = [];               
            $scope.activityLineChart.series.splice(0,0,engagementLine);
            $scope.activityLineChart.series.splice(0,0,reachLine);
            $scope.activityLineChart.series.splice(0,0,impressionsLine);
            $scope.activityLineChart.title.text = "Performance Timeline";    
            // $scope.$broadcast('highchartsng.reflow');

            $scope.printActivityLineChart.series = [];
            $scope.printActivityLineChart.series.splice(0, 0, engagementLine);
            $scope.printActivityLineChart.series.splice(0, 0, reachLine);
            $scope.printActivityLineChart.series.splice(0, 0, impressionsLine);
            $scope.printActivityLineChart.title.text = "Performance Timeline";        
        }


        // first initiating
        getDataPerformanceReportTimelineChart();
    }]);
})();